import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';

// Onda operates in AU + NZ. Country picker sets the dialling code; the number is stored
// as E.164 (+61… / +64…) via onChange. A leading trunk 0 (e.g. 04xx) is stripped.
const COUNTRIES = [
  { code: 'AU', dial: '+61', flag: '🇦🇺', placeholder: '412 345 678' },
  { code: 'NZ', dial: '+64', flag: '🇳🇿', placeholder: '21 123 4567' },
];

export default function PhoneInput({ onChange, defaultCountry = 'AU' }) {
  const [country, setCountry] = useState(defaultCountry);
  const [national, setNational] = useState('');

  const cfg = COUNTRIES.find((c) => c.code === country) || COUNTRIES[0];

  const emit = (dial, digits) => onChange?.(digits ? `${dial}${digits}` : '');

  const handleNational = (raw) => {
    // digits only, drop the national trunk 0 (04xx -> 4xx) so it appends cleanly to +61/+64
    const digits = raw.replace(/\D/g, '').replace(/^0+/, '');
    setNational(digits);
    emit(cfg.dial, digits);
  };

  const handleCountry = (c) => {
    setCountry(c);
    const next = COUNTRIES.find((x) => x.code === c) || COUNTRIES[0];
    emit(next.dial, national);
  };

  // AU/NZ mobiles are ~9 digits national (8–10 covers the carriers); backend is authoritative.
  const validLen = national.length >= 8 && national.length <= 10;

  return (
    <div>
      <div className="flex gap-2">
        <Select value={country} onValueChange={handleCountry}>
          <SelectTrigger className="w-[120px] bg-card border-border shrink-0">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {COUNTRIES.map((c) => (
              <SelectItem key={c.code} value={c.code}>{c.flag} {c.dial}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input
          type="tel"
          inputMode="numeric"
          autoComplete="tel-national"
          placeholder={cfg.placeholder}
          value={national}
          onChange={(e) => handleNational(e.target.value)}
          className="bg-card border-border flex-1"
        />
      </div>
      {national && !validLen && (
        <p className="text-xs text-red-500 mt-1">Enter a valid {country} mobile number.</p>
      )}
    </div>
  );
}
